
import Vue from "vue";
import { IContainer } from "@/shared/models/container.model";
import { INode } from "@/shared/models/node.model";
import { HtmlHelper } from "@/shared/lib/htmlhelper";
import { MarkHelper } from "@/shared/lib/markhelper";

export default Vue.extend({
    name: "BreadCrumb",

    props: {
        item: Object as () => IContainer,
        chapter: Object as () => INode,
        phrase: String as () => string
    },
    data() {
        return {
        };
    },
    mounted() {
        window.addEventListener("scroll", this.handleSticky);
    },
    methods: {
        getStartPage(): string {
            const helper = new HtmlHelper();
            return helper.getBaseUrl();
        },
        getChapterPage(): string {
            return this.getStartPage() + this.chapter.Url;
        },
        getChapterName() : string {
            const helper = new MarkHelper();
            const chapterName = helper.addMarkInText(this.chapter.Name, this.phrase);
            return chapterName;
        },
        getBreadCrumb() : string {
            let breadCrumb = ""
            const firstSubNode = 1;
            const lastSubNode = this.item?.BreadCrumb?.length ?? 0;

            if(lastSubNode > firstSubNode){
                breadCrumb = " / ";
                breadCrumb += this.item.BreadCrumb.slice(firstSubNode,lastSubNode).join(" / ");
            }
            const helper = new MarkHelper();
            breadCrumb = helper.addMarkInText(breadCrumb, this.phrase);
            return breadCrumb;
        },
        handleSticky(){
            const breadCrumb = document.querySelector(".bread-crumbs");
            if (window.innerWidth >= 968 && window.pageYOffset > 200 && !breadCrumb?.classList.contains("sticky")) {
                breadCrumb?.classList.add("sticky");
            }else if(window.innerWidth >= 968 && window.pageYOffset < 200 && breadCrumb?.classList.contains("sticky")){
                breadCrumb?.classList.remove("sticky");
            }
            
            if (window.innerWidth < 968 && window.pageYOffset > 114 && !breadCrumb?.classList.contains("sticky")) {
                breadCrumb?.classList.add("sticky");
            }else if(window.innerWidth < 968 && window.pageYOffset < 114 && breadCrumb?.classList.contains("sticky")){
                breadCrumb?.classList.remove("sticky");
            }
        }
    },

});
